import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IActivateAccount,
  IPasswordResetPayload,
  ISendCodeRequest,
  PasswordReset,
} from '@patient-ui/shared/models';
import { EnvironmentService } from '@patient-ui/shared-ui/utils';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private readonly http: HttpClient,
    private envService: EnvironmentService
  ) {}

  getPasswordResetPayload(
    passwordResetPayload: IPasswordResetPayload
  ): Observable<PasswordReset> {
    return this.http.post<PasswordReset>(
      `${this.envService.baseUrl}/guest/accounts/${passwordResetPayload.email}/password/initiateReset`,
      passwordResetPayload.recaptchaToken
    );
  }

  sendPasswordResetVerifyCode(
    email: string,
    sendCodeRequest: ISendCodeRequest
  ): Observable<IActivateAccount> {
    return this.http.post<IActivateAccount>(
      `${this.envService.baseUrl}/guest/accounts/${email}/password/sendCode`,
      sendCodeRequest
    );
  }

  validatePasswordResetVerifyCode(
    pin: number,
    token: string,
    email: string
  ): Observable<IActivateAccount> {
    const httpOptions = {
      token: token,
      code: pin.toString(),
    };
    return this.http.post<IActivateAccount>(
      `${this.envService.baseUrl}/guest/accounts/${email}/password/validateCode`,
      httpOptions
    );
  }

  setNewPassword(
    newPassword: string,
    token: string,
    email: string
  ): Observable<boolean> {
    const httpOptions = {
      newPassword,
      token,
      email,
    };
    return this.http.post<boolean>(
      `${this.envService.baseUrl}/guest/accounts/${email}/password`,
      httpOptions
    );
  }
}
